import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";
import {
  ClientCredit,
  ClientLoyaltyProgress,
  CreateServicePackagePayload,
  CreditTransaction,
  ServicePackage,
  UpdateServicePackagePayload,
} from "../types/servicePackage";

const api = new APIClient();

const RESOURCE = "/service-packages";

export type {
  ServicePackage,
  CreateServicePackagePayload,
  UpdateServicePackagePayload,
  ClientCredit,
  ClientLoyaltyProgress,
  CreditTransaction,
} from "../types/servicePackage";

export interface ServicePackageListParams extends PaginationParams {
  unit_id?: number;
  service_id?: number;
  search?: string;
  is_active?: boolean;
}

export const getServicePackages = (
  params?: ServicePackageListParams
): Promise<PaginatedApiResponse<ServicePackage>> =>
  api.get<PaginatedApiResponse<ServicePackage>>(RESOURCE, params);

export const getServicePackage = (
  id: number
): Promise<ApiResponse<ServicePackage>> =>
  api.get<ApiResponse<ServicePackage>>(`${RESOURCE}/${id}`);

export const createServicePackage = (
  payload: CreateServicePackagePayload
): Promise<ApiResponse<ServicePackage>> =>
  api.create<ApiResponse<ServicePackage>>(RESOURCE, payload);

export const updateServicePackage = (
  id: number,
  payload: UpdateServicePackagePayload
): Promise<ApiResponse<ServicePackage>> =>
  api.update<ApiResponse<ServicePackage>>(`${RESOURCE}/${id}`, payload);

export const deleteServicePackage = (
  id: number
): Promise<ApiResponse<Record<string, never>>> =>
  api.delete<ApiResponse<Record<string, never>>>(`${RESOURCE}/${id}`);

export interface ClientCreditListParams extends PaginationParams {
  service_id?: number;
}

export const getClientCredits = (
  clientId: number,
  params?: ClientCreditListParams
): Promise<PaginatedApiResponse<ClientCredit>> =>
  api.get<PaginatedApiResponse<ClientCredit>>(
    `/clients/${clientId}/credits`,
    params
  );

export const getClientLoyalty = (
  clientId: number
): Promise<ApiResponse<ClientLoyaltyProgress[]>> =>
  api.get<ApiResponse<ClientLoyaltyProgress[]>>(`/clients/${clientId}/loyalty`);

export interface ClientCreditTransactionListParams extends PaginationParams {
  movement_type?: string;
  from_date?: string;
  to_date?: string;
}

export const getClientCreditTransactions = (
  clientId: number,
  params?: ClientCreditTransactionListParams
): Promise<PaginatedApiResponse<CreditTransaction>> =>
  api.get<PaginatedApiResponse<CreditTransaction>>(
    `/clients/${clientId}/credit-transactions`,
    params
  );

export interface ExpiringCreditsSummary {
  within_days: number;
  lots_expiring: number;
}

export const getExpiringCreditsSummary = (
  withinDays = 30
): Promise<ApiResponse<ExpiringCreditsSummary>> =>
  api.get<ApiResponse<ExpiringCreditsSummary>>(
    "/client-credits/expiring-summary",
    { within_days: withinDays }
  );
